import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { TitleWrapper } from './styles';

const ModuleTitleWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { t } = useTranslation();
    return <TitleWrapper>{children}</TitleWrapper>;
};

export default ModuleTitleWrapper;
